import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter, Switch } from 'react-router-dom';
import loadable from '@loadable/component';

// Styles.
import 'styles';

// Containers.
import AuthNotRequireClearContainer from 'containers/AuthNotRequireClearContainer';

const ReportBloodPressureNewsfeedPage = loadable(() => import('containers/ReportBloodPressureNewsfeedPage'));

const ShareCorrelationPage = loadable(() => import('containers/ShareCorrelationPage'));

const NotFoundPage = loadable(() => import('containers/NotFoundPage'));
const ErrorPage = loadable(() => import('containers/ErrorPage'));

@withRouter
@connect(
  state => ({
    i18n: state.i18n,
  })
)
export default class AppContainer extends Component {

  static propTypes = {
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    children: PropTypes.element,
  };

  render() {
    return (
      <React.Fragment>
        <div className="appWrapper">
          <Switch>

            <AuthNotRequireClearContainer path="/history-bp" component={ReportBloodPressureNewsfeedPage} theme="ink" />

            <AuthNotRequireClearContainer path="/share-correlation" component={ShareCorrelationPage} theme="ink" />

            <AuthNotRequireClearContainer path="/error" component={ErrorPage} theme="ink" />

            <AuthNotRequireClearContainer path="/page-404" component={NotFoundPage} status={404} theme="ink" />

            <AuthNotRequireClearContainer component={NotFoundPage} status={404} theme="ink" />

          </Switch>
        </div>
      </React.Fragment>
    );
  }

}
